import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { UpdateGenericFormTextRequest } from '@/definitions/intakeForm'
import { UpdateGenericFormText } from '@/services/IntakeFormService'
import { isTimeoutError } from '@/utils/apiErrors'

interface UpdateGenericFormTextVariables {
  orgId: string
  baseFormId: string
  data: UpdateGenericFormTextRequest
}

export const useUpdateGenericFormText = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orgId, baseFormId, data }: UpdateGenericFormTextVariables) =>
      UpdateGenericFormText(orgId, baseFormId, data),
    // A refusal names the title that was submitted, so the caller shows it on
    // that field rather than as a toast.
    meta: { suppressGlobalError: true },
    onSuccess: (_form, { orgId, baseFormId }) => {
      // The list carries the form's name, which the title just changed.
      queryClient.invalidateQueries({ queryKey: ['intakeForms', orgId] })
      queryClient.invalidateQueries({
        queryKey: ['genericFormText', orgId, baseFormId],
      })
    },
    // Unlike a refusal, a timeout may have committed — so what is cached is a guess.
    onError: (error, { orgId, baseFormId }) => {
      if (isTimeoutError(error)) {
        queryClient.invalidateQueries({ queryKey: ['intakeForms', orgId] })
        queryClient.invalidateQueries({
          queryKey: ['genericFormText', orgId, baseFormId],
        })
      }
    },
  })
}
